import { useCallback } from 'react';
import { sounds } from '../sounds';

export const useSound = (isMuted: boolean) => {
  const triggerSound = useCallback((key: keyof typeof sounds) => {
    if (!isMuted) {
      sounds[key]();
    }
  }, [isMuted]);

  return { triggerSound };
};
